import { MantineSpacing, StyleProp } from '@mantine/core';

export function useLayoutHorizontalSpacing() {
  const spacing: StyleProp<MantineSpacing> = {
    base: 'md',
    md: '7.5rem',
    lg: '15rem',
  };
  return spacing;
}
